import React from "react";
import { Box, Typography, FormControlLabel, Checkbox } from "@material-ui/core";
import clsx from "clsx";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useSelector } from "react-redux";
import countries from "../../../utils/countries.json";
import OptimizedTooltip from "../../common/OptimizedTooltip";
import Form from "../../common/Form";

export default function StripeBilling({
  classes,
  errors,
  inputValues,
  handleChange,
  checked,
  setChecked,
  handleSelect,
  selectValues
}) {
  const billingDetails = useSelector(state => state.account.billingDetails);
  return (
    <Box className={classes.borderLeftRadius} width="100%" px={3} py={4}>
      <Typography className={classes.title}>Billing information</Typography>

      {(billingDetails.address_line1 || billingDetails.postal_code) && (
        <FormControlLabel
          className={classes.checkbox}
          control={
            <Checkbox
              checked={checked}
              onChange={() => setChecked(!checked)}
              value="checkedF"
              color="primary"
            />
          }
          label="Same as invoice address"
        />
      )}
      {/* Form */}
      <Form
        data={[
          [
            {
              labelId: "reg-country",
              selectId: "reg-country-select",
              label: "Country",
              name: "country",
              options: countries,
              shrink: true,
              choose: true,
              dataCy: "country",
              onChange: e => handleSelect(e),
              componentType: "select"
            }
          ],
          [
            {
              renderInputField: true,
              label: "Address line 1",
              name: "address",
              type: "text",
              dataCy: "address"
            }
          ],
          [
            {
              renderInputField: true,
              label: <span>Address line 2</span>,
              name: "address2",
              type: "text",
              dataCy: "address2"
            }
          ],
          [
            {
              renderInputField: true,
              label: "City",
              name: "city",
              type: "text",
              dataCy: "city"
            }
          ],
          [
            {
              renderInputField: true,
              label: "State/Provice/Region",
              name: "region",
              type: "text",
              dataCy: "region"
            },
            {
              renderInputField: true,
              label: "Zip or Postal Code",
              name: "zipcode",
              type: "text",
              dataCy: "zipcode"
            }
          ]
        ]}
        handleChange={handleChange}
        selectValues={selectValues}
        inputValues={inputValues}
        errorValues={errors}
      />
      <Box display="flex" mt={0.5}>
        <Typography className={clsx(classes.title, classes.vatTitle)}>
          VAT Number
        </Typography>

        <Box display="flex" alignItems="center" ml={1.5}>
          <OptimizedTooltip
            PopperProps={{
              className: "tooltip-info-window"
            }}
            placement="bottom-start"
            title={
              <Box className={classes.tooltipBody} p={1.5}>
                <Typography className={classes.tooltipText}>
                  If you have a registered business within the EU, you can use
                  your VAT number to have the VAT charge deducted from your
                  invoice. VAT IDs typically contain a two-letter country code
                  following by digits and letters. For example, Routetitan’s VAT
                  ID is NL 855072738B01.
                </Typography>
              </Box>
            }
          >
            <InfoOutlinedIcon fontSize="small" className="tooltipOpener" />
          </OptimizedTooltip>
        </Box>
      </Box>
      <Box display="flex" alignItems="start">
        <Box className={classes.countryIndicator}>{selectValues.country}</Box>
        {/* VAT ID */}
        <Form
          data={[
            [
              {
                renderInputField: true,
                label: (
                  <span>
                    VAT Tax ID Number <i>(Optional)</i>
                  </span>
                ),
                name: "vatID",
                type: "text",
                dataCy: "vatID"
              }
            ]
          ]}
          handleChange={handleChange}
          inputValues={inputValues}
          errorValues={errors}
        />
      </Box>
    </Box>
  );
}
